module.exports = __webpack_public_path__ + "img/pg3-article3-c1.7f512db3.png";